<template>
  <div class="video-test">
<!--   <input-video :file.sync="file"></input-video>

    <input type="file"
           @input="onUploadFile($event)"
           accept="video/*">-->

    <!--<drag-img-multiple></drag-img-multiple>-->
    <div class="flex-end">
      <button class="button" @click="saveText">저장하기</button>
    </div>
    <div class="flex">
      <div v-for="(item, item_idx) in variables" :key="`item-${item_idx}`"
           class="unselect"
           style="border:1px solid;margin-right:6px" @click="selectVariable(item)">{{ item.val }}</div>
    </div>
    <div ref="editor" id="editor" contenteditable="true" style="border:1px solid #ddd;height:200px"
         @input="inputText" @keydown="keyDown">

    </div>
  </div>
</template>

<script>
  import InputVideo from "../../module/common/InputVideo";
  import DragImgMultiple from "../../module/common/DragImgMultiple";

  export default {
    components: {DragImgMultiple, InputVideo},
    name: "video-test",
    data() {
      return {
        variables: [{key:'user_name', val:'회원명'},{key:'user_email', val:'회원이메일'}],
        text: '',
        file: ''
      }
    },
    created() {
      this.$nextTick(()=> {
        this.$refs.editor.innerHTML = '';
        this.setVariables();
      })
    },
    methods: {
      setVariables() {
        this.variables.forEach(item=>{
          item.html = `<span id="tag" contenteditable="false" key="${item.key}">${ item.val }</span>`;
        });
      },
      keyDown(event) {
        let KeyID = event.keyCode;
        switch(KeyID)
        {
          case 8:
            // alert("backspace");
            break;
          case 46:
            // alert("delete");
            break;
          default:
            break;
        }
      },
      // 변수 선택
      selectVariable(item) {
        this.$refs.editor.innerHTML += `${item.html}  &nbsp;`
      },
      inputText(e) {
        this.text = e.target.innerText;
      },
      saveText() {
        let html = this.$refs.editor.innerHTML;
        this.variables.forEach(item => {
          let exp = new RegExp(item.html, 'gi');
          html = html.replace(exp, `#{${item.key}}`);
          // this.$refs.editor.innerHTML = html.replace(exp, `#{${item.key}}`);
        })
        console.log(html)
      },
      onUploadFile(evt){
        console.log(evt.target);
        this.file = evt.target.files[0];
        // let formData = new FormData();
        // formData.append('f', this.video.file)
        this.$axios.post('public/upload/video', {
          file: this.file
        })
          .then(res => {
            console.log('uploaded');
            this.video.url = res.data.url;
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus">
  @import '~assets/css/lp_main'

  .video-test #tag
    background-color $primary !important
    color white
</style>
